<template>
	<div>
		<div class="p-16 box radius-8">
			<div class="color-gy-9 fz-14 fw-500">
				样品订单是否协作至热度星选
				<el-switch
					:value="isCoopration"
					inactive-color="#E2E3E8"
					:active-value="activeValue"
					:inactive-value="inactiveValue"
					@change="confirm"
				></el-switch>
			</div>
			<div class="mt-16 yx-color-text-regular font-h6-regular">
				<p class="mt-12">开启后来自热度星选团长的商品，将同步至热度星选进行样品协作，当前支持协同平台：抖音、快手</p>
				<p class="mt-6">
					自动同步样品协作
					<el-switch
						:value="isAudit"
						inactive-color="#E2E3E8"
						:active-value="activeValue"
						:inactive-value="inactiveValue"
						@change="changeAudit"
					></el-switch>
				</p>
			</div>
		</div>
		<el-dialog
			custom-class="dialog-content"
			:append-to-body="true"
			title="提示"
			:visible.sync="dialogVisible"
			width="400px"
			:before-close="handleClose"
		>
			关闭将无法再协同至热度星选，已协同的样单不受影响，是否确认关闭？
			<span slot="footer">
				<el-button @click="handleClose">取消</el-button>
				<el-button type="primary" @click="submit" :loading="btnLoading">确认</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import {
	partnerCooperateEnable,
	partnerCooperateDisable,
	partnerCooperateStatus,
	autoPartnerCooperateEnable,
	autoPartnerCooperateDisable,
} from '@/api/settings';
export default {
	components: {},
	data() {
		return {
			activeValue: 1,
			inactiveValue: 0,
			isCoopration: 1, // 开关状态
			isAudit: 1,
			dialogVisible: false,
			btnLoading: false,
		};
	},
	created() {
		this.getAudit();
	},
	methods: {
		async getAudit() {
			try {
				let { switchAutoCooperatePartner, switchCooperatePartner } = await partnerCooperateStatus();
				this.isCoopration = +switchCooperatePartner;

				this.isAudit = +switchAutoCooperatePartner;
			} catch (error) {
				console.log(error);
			}
		},
		async changeAudit() {
			this.isAudit === 1 ? await autoPartnerCooperateDisable() : await autoPartnerCooperateEnable();
			this.$message.success('操作成功！');

			this.isAudit = +!this.isAudit;
		},
		confirm() {
			if (this.isCoopration === 1) {
				this.dialogVisible = true;
			} else {
				this.submit();
			}
		},

		handleClose() {
			this.dialogVisible = false;
		},
		submit() {
			// 开关更改为相反的状态
			if (+this.isCoopration === 0) {
				this.handleEnable();
			} else {
				this.handleDisable();
			}
		},
		async handleEnable() {
			try {
				this.btnLoading = true;
				await partnerCooperateEnable();
				this.$message.success('操作成功！');
				this.btnLoading = false;
				this.isCoopration = 1;
			} catch (error) {
				console.log(error);
				this.btnLoading = false;
			}
		},
		async handleDisable() {
			try {
				this.btnLoading = true;
				await partnerCooperateDisable();
				this.$message.success('操作成功！');
				this.dialogVisible = false;
				this.btnLoading = false;
				this.isCoopration = 0;
			} catch (error) {
				console.log(error);
				this.btnLoading = false;
			}
		},
	},
};
</script>
<style lang="less" scoped>
.box {
	background: #f7f8fa;
}
.fw-500 {
	font-weight: 500 !important;
}
</style>
